import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../utils/api";
import { toast } from "react-toastify";

export const fetchNotificationTargets = createAsyncThunk(
  "notifications/fetchTargets",
  async ({ page, pageSize, query, itemType }, { rejectWithValue }) => {
    try {
      const params = {
        page: page + 1,
        limit: pageSize,
      };

      if (query.trim()) {
        params.search = query.trim();
      }

      let endpoint = "/users";

      if (itemType === "specific-shops" || itemType === "specific-factories") {
        endpoint = "/vendors";
        params.type = itemType === "specific-shops" ? "shop" : "factory";
      }

      const response = await api.get(endpoint, { params });
      return {
        items: response.data.data,
        total: response.data.total || response.data.data.length,
      };
    } catch (error) {
      toast.error(`فشل في تحميل البيانات`);
      return rejectWithValue(error.message);
    }
  }
);

const notificationsSlice = createSlice({
  name: "notifications",
  initialState: {
    items: [],
    loading: false,
    page: 0,
    pageSize: 10,
    totalItems: 0,
    query: "",
    currentItemType: "",
    showDataGrid: false,
    selectedItemIds: [],
  },
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
      state.page = 0;
    },
    setQuery: (state, action) => {
      state.query = action.payload;
      state.page = 0;
    },
    setCurrentItemType: (state, action) => {
      state.currentItemType = action.payload;
    },
    setShowDataGrid: (state, action) => {
      state.showDataGrid = action.payload;
    },
    setSelectedItemIds: (state, action) => {
      state.selectedItemIds = action.payload;
    },
    resetTargets: (state) => {
      state.items = [];
      state.page = 0;
      state.totalItems = 0;
      state.query = "";
      state.currentItemType = "";
      state.showDataGrid = false;
      state.selectedItemIds = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchNotificationTargets.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchNotificationTargets.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.items;
        state.totalItems = action.payload.total;
      })
      .addCase(fetchNotificationTargets.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const {
  setPage,
  setPageSize,
  setQuery,
  setCurrentItemType,
  setShowDataGrid,
  setSelectedItemIds,
  resetTargets,
} = notificationsSlice.actions;

export default notificationsSlice.reducer;
